// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__RbkqT","head":"styles_head__jNI3v","buttonGroup":"styles_buttonGroup__1qlTw","button":"styles_button__CFIxB","buttonTabs":"styles_buttonTabs__T7PVz"};